import React, { createContext, useState, useContext, useCallback } from "react";
import PropTypes from "prop-types";

const BannerActiveContext = createContext({
  isBannerActive: false,
  setBannerActive: () => {},
});

export const BannerActiveProvider = ({ children }) => {
  const [isBannerActive, setIsBannerActive] = useState(false);

  const setBannerActive = useCallback((active) => {
    setIsBannerActive(!!active);
  }, []);

  return (
    <BannerActiveContext.Provider value={{ isBannerActive, setBannerActive }}>
      {children}
    </BannerActiveContext.Provider>
  );
};

BannerActiveProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useBannerActive = () => useContext(BannerActiveContext);
